import React from 'react';

function Pagination( props ) {
	const { pagination } = props;

	if ( ! props.contentLoaded ) {
		return '';
	}

	const hasPagination = pagination.last_page > 1 ? true : false;

	if ( ! hasPagination ) {
		return '';
	}

	const paginationRange = [ ...Array( pagination.last_page ).keys() ].map(
		( i ) => i + 1
	);
	const activePage = !! props.pg ? parseInt( props.pg ) : 1;

	const prevPageNo = pagination.page > 1 ? pagination.page - 1 : 1;
	const nextPageNo =
		pagination.page < pagination.last_page
			? pagination.page + 1
			: pagination.last_page;

	return (
		<nav className="pagination" aria-label="Pagination">
			{ activePage > 1 ? (
				<button
					value={ prevPageNo }
					onClick={ props.handlePage }
					className="pagination-prev"
				>
					Previous
				</button>
			) : (
				''
			) }

			{ paginationRange.map( ( item ) => (
				<button
					value={ item }
					key={ item }
					onClick={ props.handlePage }
					className={
						activePage === item
							? 'pagination-number current'
							: 'pagination-number'
					}
				>
					{ item }
				</button>
			) ) }

			{ activePage < pagination.last_page ? (
				<button
					value={ nextPageNo }
					onClick={ props.handlePage }
					className="pagination-next"
				>
					Next
				</button>
			) : (
				''
			) }
		</nav>
	);
}

export default Pagination;
